'use client';

import { FC } from 'react';
import { Check } from 'lucide-react';
import HotdeskButton from '@/hotdesk-ui/components/shared/HotdeskButton';
import styles from './PlanCard.module.scss';
export interface PlanCardProps {
  name: string;
  description: string;
  price?: string;
  badge?: string;
  features: string[];
  ctaLabel: string;
  onCtaClick?: () => void;
  onPlanWorkspacesClick?: () => void;
  planWorkspacesLabel?: string;
  highlighted?: boolean;
}
const PlanCard: FC<PlanCardProps> = ({
  name,
  description,
  price,
  badge,
  features,
  ctaLabel,
  onCtaClick,
  onPlanWorkspacesClick,
  planWorkspacesLabel,
  highlighted
}) => {
  return <div className={`${styles.card} ${highlighted ? styles.cardHighlighted : ''}`} data-sentry-component="PlanCard" data-sentry-source-file="PlanCard.tsx">
            {badge && <span className={styles.badge}>{badge.toUpperCase()}</span>}

            <div className={styles.head}>
                <h3 className={styles.name} dir="auto">{name}</h3>
                <p className={styles.description}>{description}</p>
            </div>

            <p className={styles.price}>{price}</p>

            <ul className={styles.features}>
                {features.map((feature, idx) => <li key={idx} className={styles.feature}>
                        <Check size={16} strokeWidth={2.5} className={styles.checkIcon} />
                        <span>{feature}</span>
                    </li>)}
            </ul>

            {onPlanWorkspacesClick && planWorkspacesLabel && <button type="button" className={styles.linkBtn} onClick={onPlanWorkspacesClick}>
                    {planWorkspacesLabel}
                </button>}

            <HotdeskButton variant="primary" size="md" fullWidth className={styles.cta} onClick={onCtaClick} data-sentry-element="HotdeskButton" data-sentry-source-file="PlanCard.tsx">
                {ctaLabel}
            </HotdeskButton>
        </div>;
};
export default PlanCard;